import React from 'react'

import {
  AlignItems,
  Bold,
  BorderStyle,
  Box,
  Color,
  Display,
  Icon,
  IconVariant,
  Text,
} from '@gousto-internal/citrus-react'

const NOTICE_VARIANTS = {
  warning: { color: Color.Error_50, icon: 'warning', iconVariant: IconVariant.Error },
  info: { color: Color.Informative_50, icon: 'info', iconVariant: IconVariant.Informative },
} as const

export type NoticePanelVariant = keyof typeof NOTICE_VARIANTS

export type NoticePanelProps = {
  variant: NoticePanelVariant
  title?: string
  body: string
}

export const NoticePanel = ({ variant, title, body }: NoticePanelProps) => {
  const { color, icon, iconVariant } = NOTICE_VARIANTS[variant]

  return (
    <Box
      bg={color}
      borderColor={color}
      borderStyle={BorderStyle.Solid}
      borderWidth={0.5}
      borderRadius={1.5}
      display={Display.Flex}
      alignItems={AlignItems.FlexStart}
      gap={2}
      paddingH={4}
      paddingV={4}
    >
      <Icon name={icon} variant={iconVariant} />
      <Box>
        <Text size={2}>
          {title && (
            <>
              <Bold>{title}</Bold>&nbsp;
            </>
          )}
          {body}
        </Text>
      </Box>
    </Box>
  )
}
